import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuButtonBulletedList
  from 'components/atoms/Editors/EditorMenuButtonBulletedList/EditorMenuButtonBulletedList.styles';

const EditorMenuButtonBulletedList = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'EditorMenuButtonBulletedList');

  return <StyledEditorMenuButtonBulletedList buttonRef={ref} {...innerProps} />
});

EditorMenuButtonBulletedList.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuButtonBulletedList;
